import {light} from '@fortawesome/fontawesome-svg-core/import.macro';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';

import './Spinner.scss';

export const Spinner: React.FC = () => {
  return (
    <div className="spinner">
      <FontAwesomeIcon icon={light('spinner')} pulse />
    </div>
  );
};
